import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";

import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";

class Favourites extends Component {
	constructor(props) {
		super(props);
		this.state = {
			columnDefs: [
				{ headerName: "Cantidad", field: "count", width: "100" },
				{ headerName: "Actividad", field: "descripcion", width: "300" }
			]
		};
	}

	exportFile = () => {
		/* convert state to workbook */
		let cols = this.props.favourites.map((info, i) => {
			return [info.count, info.descripcion];
		});
		let hcols = ["Cantidad", "Actividad"];
		const exp = [[...hcols], ...cols];
		const ws = XLSX.utils.aoa_to_sheet(exp);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Favoritos");
		/* generate XLSX file and send to client */
		XLSX.writeFile(wb, "Favoritos.xlsx");
	};

	componentDidMount() {}

	render() {
		return (
			<React.Fragment>
				<h2 style={{ width: "100%", textAlign: "left" }}>Ranking Favoritos</h2>

				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.exportFile}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Exportar a Excel
					</Button>
				</div>
				<div
					className="ag-theme-balham"
					style={{ height: "80vh", width: "50%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.favourites}
					></AgGridReact>
				</div>
			</React.Fragment>
		);
	}
}

export default Favourites;
